import React, { useEffect } from 'react';
import styles from './Approve.module.css';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import useAuth from '@hooks/useAuth';

const Approve = () => {
  const { t } = useTranslation();
  const [_, { verify }] = useAuth();
  const navigate = useNavigate();
  const { id } = useParams();

  const handleSuccess = ({ admin }) => {
    navigate(admin ? '/organizations' : '/places')
  }

  const handleError = () => {
    navigate('/approve/expired');
  }

  useEffect(() => {
    verify(id, handleSuccess, handleError)
  }, []);

  return ( 
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <div className={styles.title}>
          {t('check.title')}
        </div>
      </div>
    </div>
  )
}

export default Approve;
